var _style, _path, _path2, _rect, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.facebook-like .st0{fill:none;}\n\t.facebook-like .st1{fill:url(#SVGID_1_);}\n\t.facebook-like .st2{fill:url(#SVGID_00000176039526782252761810000002655843910266884281_);}\n\t.facebook-like .st3{fill:url(#SVGID_00000147922952048010203360000000781632489221131443_);}\n\t.facebook-like .st4{fill:url(#SVGID_00000023274908413840733600000011407438308526889344_);}\n\t.facebook-like .st5{fill:url(#SVGID_00000146467761580216897750000000768091872251171503_);}\n\t.facebook-like .st6{fill:url(#SVGID_00000178902219882374319580000017565873045684628365_);}\n\t.facebook-like .st7{fill:url(#SVGID_00000129903120881896194520000002568595402604624024_);}\n\t.facebook-like .st8{fill:url(#SVGID_00000109029399976989226900000000465687507996654241_);}\n\t.facebook-like .st9{fill:url(#SVGID_00000106840523965873367390000003647343990884808368_);}\n\t.facebook-like .st10{fill:url(#SVGID_00000076591733309481602600000006548258393916092852_);}\n\t.facebook-like .st11{fill:url(#SVGID_00000181081323398965406360000016359708425129595280_);}\n\t.facebook-like .st12{fill:url(#SVGID_00000182503876721218869900000004031685984128779917_);}\n\t.facebook-like .st13{fill:url(#SVGID_00000083811952373117194330000011943853504011134398_);}\n\t.facebook-like .st14{fill:url(#SVGID_00000054258197244109510090000009944132603828395702_);}\n\t.facebook-like .st15{fill:url(#SVGID_00000165214652790198462110000010216103018740719234_);}\n\t.facebook-like .st16{fill:url(#SVGID_00000105386817521886134690000011804543674162206093_);}\n\t.facebook-like .st17{fill:url(#SVGID_00000063615047189075478210000002936754797660455571_);}\n\t.facebook-like .st18{fill:url(#SVGID_00000143579881523048991720000007132285101586835618_);}\n\t.facebook-like .st19{fill:url(#SVGID_00000091719778329863150760000009931909093536725890_);}\n\t.facebook-like .st20{fill:url(#SVGID_00000053518692132183921100000008592232696808571834_);}\n\t.facebook-like .st21{fill:url(#SVGID_00000109726281983659541060000009659625881300263863_);}\n\t.facebook-like .st22{fill:url(#SVGID_00000078749020879034339530000008198324275014626234_);}\n\t.facebook-like .st23{fill:url(#SVGID_00000089560379556971112620000017189925797323153818_);}\n\t.facebook-like .st24{fill:url(#SVGID_00000029741582593709282960000014210660411013013431_);}\n\t.facebook-like .st25{fill:url(#SVGID_00000024702258244650271760000015418687434182338180_);}\n\t.facebook-like .st26{fill:url(#SVGID_00000028316525920878724850000016858193904262177170_);}\n\t.facebook-like .st27{fill:url(#SVGID_00000111193747325575033320000011782220072852895670_);}\n\t.facebook-like .st28{fill:url(#SVGID_00000130638518852209815250000017380602740557576638_);}\n\t.facebook-like .st29{fill:url(#SVGID_00000013894958392771788820000013621646795247373497_);}\n\t.facebook-like .st30{fill:url(#SVGID_00000013166519590522759600000016097648616240052880_);}\n\t.facebook-like .st31{fill:url(#SVGID_00000071519033479132326050000000750889852998629541_);}\n\t.facebook-like .st32{fill:url(#SVGID_00000110472815347221133790000011882835307815896503_);}\n\t.facebook-like .st33{fill:url(#SVGID_00000063609352919487754570000000198983784442263178_);}\n\t.facebook-like .st34{fill:url(#SVGID_00000163777838036857759950000007399269496928360342_);}\n\t.facebook-like .st35{fill:url(#SVGID_00000071527813789487700940000007295424375021866916_);}\n\t.facebook-like .st36{fill:url(#SVGID_00000046334943247289657890000015797450538581268375_);}\n\t.facebook-like .st37{fill:url(#SVGID_00000105387024076435022800000012137008746358839704_);}\n\t.facebook-like .st38{fill:url(#SVGID_00000052078662364852068350000016755379970665019264_);}\n\t.facebook-like .st39{fill:url(#SVGID_00000153680674491443415040000014628816932721598385_);}\n\t.facebook-like .st40{fill:url(#SVGID_00000139288308653683143550000003854250606713027507_);}\n\t.facebook-like .st41{fill:#CECECE;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "facebook-like"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.39,15.35h2.63l0.21-2.3h-2.71v-0.6c0-0.16,0-0.32,0-0.47c0-0.37-0.01-0.72,0.01-1.08 c0.04-0.77,0.56-1.25,1.36-1.26c0.34,0,0.68,0,1.02,0l0.32,0V7.81c-0.17,0-0.33,0-0.49,0.01c-0.82,0.01-1.6,0.02-2.37,0.1 c-1.13,0.13-1.86,0.79-2.17,1.98c-0.08,0.33-0.11,0.69-0.13,1.1c-0.02,0.32-0.01,0.64-0.01,0.99c0,0.16,0,0.31,0,0.47v0.6h-1.72 v2.3c0.29,0,0.58,0,0.86-0.01c0.1,0,0.41-0.01,0.65,0.22c0.24,0.23,0.24,0.54,0.24,0.66c-0.01,2.16,0,4.32,0,6.48l0,1.36h2.3V15.35 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.7215,
    y1: 9.9319,
    x2: 22.536,
    y2: 35.1894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.66,24.3c0,0.03,0.02,0.05,0.02,0.08c-0.01-0.03-0.02-0.06-0.02-0.1C11.67,24.29,11.66,24.29,11.66,24.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018232529619399680810000007710582665820203189_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.9808,
    y1: 9.1912,
    x2: 23.2768,
    y2: 34.4487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018232529619399680810000007710582665820203189_)"
    },
    d: "M14.43,25.66 c0.01-0.02,0.02-0.05,0.03-0.08C14.45,25.61,14.44,25.63,14.43,25.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052790895628875133270000005949567512913115794_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.4429,
    y1: 10.6534,
    x2: 21.8146,
    y2: 35.9109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052790895628875133270000005949567512913115794_)"
    },
    d: "M8.49,22.54 c-0.04-0.01-0.09-0.01-0.13-0.03C8.4,22.52,8.45,22.53,8.49,22.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175308953665317389860000006703687502625092754_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.2606,
    y1: 9.4711,
    x2: 22.9969,
    y2: 34.7286
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175308953665317389860000006703687502625092754_)"
    },
    d: "M14.12,25.93 c0.04-0.01,0.07-0.03,0.1-0.06C14.19,25.9,14.16,25.92,14.12,25.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162320512124188934450000013598429774364182925_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.8575,
    y1: 11.068,
    x2: 21.4,
    y2: 36.3255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162320512124188934450000013598429774364182925_)"
    },
    d: "M11.69,26.65 c-0.01-0.03-0.02-0.06-0.02-0.1c0,0.01,0,0.01,0,0.01C11.67,26.6,11.68,26.62,11.69,26.65z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021815201254220050770000010100351765549654934_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.5836,
    y1: 10.794,
    x2: 21.6739,
    y2: 36.0516
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021815201254220050770000010100351765549654934_)"
    },
    d: "M11.78,26.22 c0.02-0.02,0.03-0.05,0.05-0.07C11.81,26.16,11.79,26.19,11.78,26.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152230564453722507900000017015022811152452231_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.4916,
    y1: 8.702,
    x2: 23.7659,
    y2: 33.9595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152230564453722507900000017015022811152452231_)"
    },
    d: "M13.36,23.7c0.08,0,0.16-0.02,0.23-0.05 C13.52,23.68,13.45,23.7,13.36,23.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064323080225634144940000007667843697859501238_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.1497,
    y1: 8.3602,
    x2: 24.1078,
    y2: 33.6177
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064323080225634144940000007667843697859501238_)"
    },
    d: "M13.83,23.44 c0.03-0.04,0.05-0.08,0.07-0.13C13.88,23.35,13.86,23.4,13.83,23.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091712897413231278200000001305007239729886357_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.9069,
    y1: 8.1174,
    x2: 24.3506,
    y2: 33.3749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091712897413231278200000001305007239729886357_)"
    },
    d: "M13.66,22.66 c-0.03-0.02-0.07-0.04-0.1-0.06C13.59,22.62,13.62,22.64,13.66,22.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153689459962719510000000015851464238708354948_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.913,
    y1: 8.1235,
    x2: 24.3445,
    y2: 33.381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153689459962719510000000015851464238708354948_)"
    },
    d: "M13.89,22.95 c-0.01-0.03-0.02-0.05-0.03-0.08C13.88,22.9,13.89,22.93,13.89,22.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112631104151992702450000008193530594583185804_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.5976,
    y1: 9.808,
    x2: 22.6599,
    y2: 35.0655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112631104151992702450000008193530594583185804_)"
    },
    d: "M11.69,24.15 c0.01-0.03,0.01-0.06,0.02-0.09C11.7,24.09,11.69,24.12,11.69,24.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129173797967800427430000010114926850546840990_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.4474,
    y1: 9.6579,
    x2: 22.8101,
    y2: 34.9154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129173797967800427430000010114926850546840990_)"
    },
    d: "M11.78,23.94 c0.02-0.02,0.03-0.05,0.05-0.07C11.81,23.89,11.79,23.92,11.78,23.94z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106832288312473271250000008699149637201327272_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.2892,
    y1: 9.4997,
    x2: 22.9683,
    y2: 34.7572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106832288312473271250000008699149637201327272_)"
    },
    d: "M11.95,23.79 c0.02-0.01,0.04-0.03,0.06-0.04C11.99,23.76,11.97,23.77,11.95,23.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145021754173341637560000015458187284507204267_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.6808,
    y1: 10.8912,
    x2: 21.5767,
    y2: 36.1487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145021754173341637560000015458187284507204267_)"
    },
    d: "M13.66,28.15 c-0.03,0.02-0.07,0.04-0.1,0.06C13.59,28.19,13.62,28.17,13.66,28.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106866199393877936300000008759900632264343721_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.9254,
    y1: 11.1359,
    x2: 21.3321,
    y2: 36.3934
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106866199393877936300000008759900632264343721_)"
    },
    d: "M11.72,26.78c0,0.01,0.01,0.02,0.02,0.02 C11.73,26.79,11.72,26.79,11.72,26.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054225261248634890270000011876830214076691604_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.2223,
    y1: 10.4328,
    x2: 22.0352,
    y2: 35.6903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054225261248634890270000011876830214076691604_)"
    },
    d: "M13.36,27.11c0.08,0,0.16,0.02,0.23,0.05 C13.52,27.13,13.45,27.11,13.36,27.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059994191921131411070000013594691623899318458_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.1603,
    y1: 10.3707,
    x2: 22.0972,
    y2: 35.6283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059994191921131411070000013594691623899318458_)"
    },
    d: "M13.66,27.2c0.04,0.03,0.09,0.06,0.12,0.1 C13.75,27.26,13.7,27.23,13.66,27.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124143174927266878730000006245166198680646073_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.7337,
    y1: 10.9442,
    x2: 21.5238,
    y2: 36.2017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124143174927266878730000006245166198680646073_)"
    },
    d: "M11.71,26.33 c-0.01,0.03-0.01,0.06-0.02,0.09C11.69,26.39,11.7,26.36,11.71,26.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126299214926832308220000017032179959106619290_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.4254,
    y1: 10.6358,
    x2: 21.8321,
    y2: 35.8933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126299214926832308220000017032179959106619290_)"
    },
    d: "M12.01,26.02 c-0.02,0.01-0.04,0.03-0.06,0.04C11.97,26.05,11.99,26.03,12.01,26.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003795585800372016940000001524510788051959464_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.8645,
    y1: 12.0749,
    x2: 20.393,
    y2: 37.3324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003795585800372016940000001524510788051959464_)"
    },
    d: "M12.52,29.48 c0.04,0.03,0.09,0.06,0.12,0.1C12.61,29.53,12.57,29.5,12.52,29.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102502981204069489860000002797866497024956848_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.8164,
    y1: 11.0269,
    x2: 21.4411,
    y2: 36.2844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102502981204069489860000002797866497024956848_)"
    },
    d: "M13.36,28.24c0.03,0,0.05-0.01,0.08-0.02 c-0.03,0-0.06,0.02-0.09,0.02H13.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171711604335798476520000015047385470359705275_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.5441,
    y1: 10.7546,
    x2: 21.7134,
    y2: 36.0121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171711604335798476520000015047385470359705275_)"
    },
    d: "M13.8,28.03 c-0.02,0.02-0.04,0.05-0.06,0.07C13.76,28.08,13.78,28.05,13.8,28.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051371185923450374460000006176576831982216381_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.9265,
    y1: 12.137,
    x2: 20.331,
    y2: 37.3945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051371185923450374460000006176576831982216381_)"
    },
    d: "M12.23,29.38c0.08,0,0.16,0.02,0.23,0.05 C12.39,29.4,12.31,29.38,12.23,29.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072992198572597123690000013476782014943667094_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.1811,
    y1: 10.3916,
    x2: 22.0764,
    y2: 35.6491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072992198572597123690000013476782014943667094_)"
    },
    d: "M13.83,27.37 c0.03,0.04,0.05,0.08,0.07,0.13C13.88,27.45,13.86,27.41,13.83,27.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119836470177084816410000007757928151102538941_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.2706,
    y1: 10.4811,
    x2: 21.9869,
    y2: 35.7386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119836470177084816410000007757928151102538941_)"
    },
    d: "M13.93,27.68c0-0.03-0.01-0.05-0.02-0.08 c0.01,0.05,0.01,0.1,0,0.15C13.92,27.72,13.93,27.7,13.93,27.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078760839445424441310000014402751966611103412_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.4009,
    y1: 10.6114,
    x2: 21.8566,
    y2: 35.8689
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078760839445424441310000014402751966611103412_)"
    },
    d: "M13.89,27.85 c-0.01,0.03-0.02,0.05-0.03,0.08C13.88,27.9,13.89,27.88,13.89,27.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171681253989822828690000016371769852671877300_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.7893,
    y1: 9.9998,
    x2: 22.4682,
    y2: 35.2573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171681253989822828690000016371769852671877300_)"
    },
    d: "M11.74,24.53c0-0.01-0.01-0.02-0.02-0.02 C11.72,24.51,11.73,24.52,11.74,24.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005248030468007490630000000145820540181371038_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.8721,
    y1: 12.0826,
    x2: 20.3854,
    y2: 37.3401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005248030468007490630000000145820540181371038_)"
    },
    d: "M12.71,29.66c0-0.01-0.01-0.01-0.01-0.02 C12.7,29.65,12.7,29.66,12.71,29.66C12.7,29.66,12.7,29.66,12.71,29.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000911362256325358020000012948474584047034526_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.8504,
    y1: 9.0608,
    x2: 23.4071,
    y2: 34.3184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000911362256325358020000012948474584047034526_)"
    },
    d: "M14.48,25.32c0.01,0.05,0.01,0.1,0,0.15 c0-0.02,0.01-0.04,0.01-0.07C14.5,25.37,14.49,25.35,14.48,25.32z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028305519199274508980000015330421618156922283_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.4276,
    y1: 9.638,
    x2: 22.8299,
    y2: 34.8955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028305519199274508980000015330421618156922283_)"
    },
    d: "M8.03,21.96l-0.02-4l0.02,4.04 c0,0.22,0.12,0.4,0.3,0.49C8.16,22.38,8.03,22.18,8.03,21.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154412743671685915580000011549647063642567053_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.124,
    y1: 9.3344,
    x2: 23.1335,
    y2: 34.592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154412743671685915580000011549647063642567053_)"
    },
    d: "M14.36,25.76 c-0.02,0.02-0.04,0.05-0.06,0.07C14.32,25.8,14.34,25.78,14.36,25.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091712073549606387340000012770182212569570195_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.1522,
    y1: 2.0583,
    x2: 30.4097,
    y2: 27.3158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091712073549606387340000012770182212569570195_)"
    },
    d: "M3.3,22.06c0.29-0.68,0.76-1.66,1.42-2.65 c0.73-1.1,0.88-1.28,1.07-1.98c0.14-0.51,0.54-1.08,1.05-1.18c0.13-0.02,0.39-0.04,0.51-0.04c0.94-0.04,1.79,0.81,1.79,1.75 l0.02,3.47h4.19c0.19,0,0.37,0.04,0.54,0.09c0-1.66,0-3.31,0-4.97c-0.24,0-0.48,0-0.72,0c-0.14,0-0.29,0-0.43,0h-0.6v-4.68h1.72 c0-0.3,0-0.62,0.01-0.92c0.02-0.46,0.05-0.9,0.16-1.34c0.43-1.67,1.56-2.69,3.19-2.87c0.83-0.09,1.67-0.1,2.49-0.11 c0.36,0,0.72-0.01,1.08-0.02l0.61-0.02v4.25l-1.52,0c-0.33,0-0.66,0-1,0c-0.12,0-0.16,0.03-0.17,0.03c0,0-0.02,0.03-0.02,0.1 c-0.02,0.29-0.01,0.58-0.01,0.89h2.83l-0.43,4.69h-2.52v8.71h-2.97c0,0.05,0.02,0.1,0.02,0.15c0,0.6-0.32,1.13-0.79,1.44 c0.14,0.25,0.22,0.53,0.22,0.84c0,0.79-0.53,1.45-1.26,1.64c0.04,0.11,0.07,0.22,0.09,0.34c4.05,0,7.61,0,10.94,0 c3.17,0,5.76-2.57,5.77-5.72c0.02-5.48,0.02-11,0-16.38c-0.01-3.08-2.62-5.69-5.7-5.7c-2.26-0.01-4.54-0.01-6.8-0.01 c-1.9,0-3.79,0-5.65,0l-3.93,0C7.74,1.85,7.02,2,6.38,2.3C4.03,3.39,2.87,5.16,2.83,7.7c-0.03,1.86-0.02,3.75-0.02,5.57 c0,0.82,0.01,1.64,0.01,2.46l0,2.48c0,1.26,0,2.52,0,3.78h0.1C3.05,21.99,3.18,22.02,3.3,22.06z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116234658234894912570000016473208177164861579_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.3962,
    y1: 9.6067,
    x2: 22.8613,
    y2: 34.8642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116234658234894912570000016473208177164861579_)"
    },
    d: "M14.01,25.96c-0.03,0-0.06,0.02-0.09,0.02 h0.02C13.96,25.97,13.98,25.96,14.01,25.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147900073006519147750000000705625586137258626_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.313,
    y1: 8.5235,
    x2: 23.9445,
    y2: 33.781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147900073006519147750000000705625586137258626_)"
    },
    d: "M13.78,23.51 c-0.03,0.04-0.08,0.07-0.12,0.1C13.7,23.58,13.75,23.55,13.78,23.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129173128364208474210000006282476767209926294_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.9838,
    y1: 8.1943,
    x2: 24.2737,
    y2: 33.4518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129173128364208474210000006282476767209926294_)"
    },
    d: "M13.35,22.56c0.03,0,0.06,0.01,0.09,0.02 c-0.03,0-0.05-0.02-0.08-0.02H13.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160873854432257341600000003827694375189379492_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.8745,
    y1: 10.0849,
    x2: 22.383,
    y2: 35.3424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160873854432257341600000003827694375189379492_)"
    },
    d: "M9.12,22.22 c0.03-0.07,0.05-0.14,0.05-0.22C9.17,22.07,9.15,22.15,9.12,22.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014610472543539455390000007668704827576797373_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.0449,
    y1: 10.2554,
    x2: 22.2126,
    y2: 35.5129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014610472543539455390000007668704827576797373_)"
    },
    d: "M9.08,22.28C9.06,22.32,9.03,22.37,9,22.4 C9.03,22.37,9.06,22.32,9.08,22.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074403152544776574380000016497953911680083600_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.2026,
    y1: 10.413,
    x2: 22.0549,
    y2: 35.6706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074403152544776574380000016497953911680083600_)"
    },
    d: "M8.81,22.52 c0.04-0.02,0.08-0.04,0.11-0.07C8.89,22.48,8.86,22.5,8.81,22.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070807320549166913340000004668581937958680478_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.343,
    y1: 10.5535,
    x2: 21.9145,
    y2: 35.811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070807320549166913340000004668581937958680478_)"
    },
    d: "M8.59,22.56c0.01,0,0.01,0,0.02,0 c0.04,0,0.08-0.02,0.12-0.02C8.68,22.55,8.63,22.56,8.59,22.56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138542213175035229160000001104195570311540388_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.8838,
    y1: 8.0943,
    x2: 24.3737,
    y2: 33.3518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D5AD7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4045,
    style: {
      stopColor: "#C69039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDBD9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138542213175035229160000001104195570311540388_)"
    },
    d: "M13.73,22.71 c0.02,0.02,0.04,0.05,0.06,0.07C13.78,22.75,13.76,22.73,13.73,22.71z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22,
    y: 23.13,
    className: "st41",
    width: 1.7,
    height: 7.38
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M12.23,28.24h1.11c0.03,0,0.06-0.01,0.09-0.02c0.04-0.01,0.08-0.01,0.11-0.02c0.04-0.01,0.07-0.04,0.1-0.06 c0.03-0.02,0.05-0.03,0.08-0.05c0.02-0.02,0.04-0.05,0.06-0.07c0.03-0.03,0.05-0.06,0.07-0.1c0.01-0.02,0.02-0.05,0.03-0.08 c0.01-0.04,0.02-0.07,0.02-0.11c0.01-0.05,0-0.1,0-0.15c0-0.03-0.01-0.06-0.02-0.09c-0.02-0.05-0.04-0.09-0.07-0.13 c-0.02-0.02-0.03-0.05-0.05-0.07c-0.03-0.04-0.08-0.07-0.12-0.1c-0.02-0.01-0.04-0.03-0.06-0.04c-0.07-0.03-0.15-0.05-0.23-0.05 H12.8h-0.54h-0.03c-0.22,0-0.4-0.13-0.5-0.31c0-0.01-0.01-0.01-0.02-0.02c-0.02-0.04-0.02-0.08-0.03-0.13 c-0.01-0.03-0.02-0.05-0.02-0.08c0-0.01,0-0.01,0-0.01c0-0.01,0-0.01,0-0.01c0-0.04,0.02-0.08,0.02-0.12 c0.01-0.03,0.01-0.06,0.02-0.09c0.02-0.04,0.04-0.08,0.07-0.11c0.02-0.02,0.03-0.05,0.05-0.07c0.03-0.04,0.08-0.06,0.12-0.08 c0.02-0.01,0.04-0.03,0.06-0.04c0.07-0.03,0.14-0.05,0.22-0.05h0.57h0.56h0.55c0.03,0,0.06-0.01,0.09-0.02 c0.04-0.01,0.08-0.01,0.11-0.02c0.04-0.01,0.07-0.04,0.1-0.06c0.03-0.02,0.05-0.03,0.08-0.05c0.02-0.02,0.04-0.05,0.06-0.07 c0.03-0.03,0.05-0.06,0.07-0.1c0.01-0.02,0.02-0.05,0.03-0.08c0.01-0.04,0.02-0.07,0.02-0.11c0.01-0.05,0-0.1,0-0.15 c0-0.03-0.01-0.06-0.02-0.09c-0.02-0.05-0.04-0.09-0.07-0.13c-0.02-0.02-0.03-0.05-0.05-0.07c-0.03-0.04-0.08-0.07-0.12-0.1 c-0.02-0.01-0.04-0.03-0.06-0.04c-0.07-0.03-0.15-0.05-0.23-0.05h-0.57H12.8h-0.54h-0.03c-0.22,0-0.4-0.13-0.5-0.31 c0-0.01-0.01-0.02-0.02-0.02c-0.02-0.04-0.02-0.08-0.03-0.13c-0.01-0.03-0.02-0.05-0.02-0.08c0-0.01,0-0.01,0-0.01 c0-0.01,0-0.01,0-0.01c0-0.04,0.02-0.08,0.02-0.12c0.01-0.03,0.01-0.06,0.02-0.09c0.02-0.04,0.04-0.08,0.07-0.11 c0.02-0.02,0.03-0.05,0.05-0.07c0.03-0.04,0.08-0.06,0.12-0.08c0.02-0.01,0.04-0.03,0.06-0.04c0.07-0.03,0.14-0.05,0.22-0.05h0.57 h0.56c0.08,0,0.16-0.02,0.23-0.05c0.02-0.01,0.04-0.03,0.06-0.04c0.04-0.03,0.09-0.06,0.12-0.1c0.02-0.02,0.03-0.05,0.05-0.07 c0.03-0.04,0.05-0.08,0.07-0.13c0.01-0.03,0.01-0.06,0.02-0.09c0.01-0.05,0.01-0.1,0-0.15c0-0.04-0.01-0.08-0.02-0.11 c-0.01-0.03-0.02-0.05-0.03-0.08c-0.02-0.04-0.04-0.07-0.07-0.1c-0.02-0.02-0.04-0.05-0.06-0.07c-0.02-0.02-0.05-0.03-0.08-0.05 c-0.03-0.02-0.07-0.04-0.1-0.06c-0.04-0.01-0.08-0.02-0.11-0.02c-0.03,0-0.06-0.02-0.09-0.02H8.6h0l0,0c-0.01,0-0.01,0-0.02,0 c-0.01,0-0.01,0-0.02,0c-0.03,0-0.05-0.02-0.08-0.02c-0.04-0.01-0.09-0.02-0.13-0.03c-0.01,0-0.02-0.01-0.03-0.02 c-0.18-0.1-0.3-0.28-0.3-0.49l-0.02-4.04c0-0.31-0.25-0.57-0.57-0.57H7.37c-0.3,0-0.55,0.22-0.59,0.51 c-0.12,0.88-0.4,1.07-1.12,2.14c-0.94,1.41-1.48,2.84-1.61,3.19v6.16c0.64,0.49,1.67,1.13,2.27,1.13h5.88 c0.03,0,0.06-0.01,0.09-0.02c0.04-0.01,0.08-0.01,0.11-0.02c0.04-0.01,0.07-0.04,0.1-0.06c0.03-0.02,0.05-0.03,0.08-0.05 c0.02-0.02,0.04-0.05,0.06-0.07c0.03-0.03,0.05-0.06,0.07-0.1c0.01-0.02,0.02-0.05,0.03-0.08c0.01-0.04,0.02-0.07,0.02-0.11 c0.01-0.05,0-0.1,0-0.15c0-0.03-0.01-0.06-0.02-0.09c-0.01-0.04-0.03-0.07-0.06-0.11c0-0.01-0.01-0.01-0.01-0.02 c-0.02-0.02-0.03-0.05-0.05-0.07c-0.03-0.04-0.08-0.07-0.12-0.1c-0.02-0.01-0.04-0.03-0.06-0.04c-0.07-0.03-0.15-0.05-0.23-0.05 h0.01c-0.31,0-0.57-0.25-0.57-0.57C11.66,28.5,11.92,28.25,12.23,28.24C12.23,28.24,12.23,28.24,12.23,28.24L12.23,28.24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,7.55c-0.01-1.82-0.73-3.54-2.04-4.85c-1.31-1.31-3.03-2.03-4.85-2.04c-4.15-0.01-8.37-0.01-12.46-0.01l-3.93,0 c-0.96,0-1.85,0.19-2.65,0.56C3.11,2.51,1.69,4.68,1.64,7.68c-0.03,1.87-0.02,3.76-0.02,5.6c0,0.82,0.01,1.63,0.01,2.45l0,2.48 c0,1.26,0,2.52,0,3.79H1.22c-0.63,0-1.14,0.51-1.14,1.14v7.38c0,0.63,0.51,1.14,1.14,1.14h1.7c0.54,0,1-0.38,1.11-0.89 c0.65,0.42,1.54,0.89,2.3,0.89h5.9c0.61,0,1.13-0.32,1.44-0.8c1.17,0,2.3,0,3.39,0c2.79,0,5.35,0,7.78,0 c3.83-0.01,6.95-3.11,6.96-6.91C31.82,18.45,31.82,12.94,31.8,7.55z M2.92,30.52h-1.7v-7.38h1.7V30.52z M12.76,30.13 c-0.01,0.03-0.02,0.05-0.03,0.08c-0.02,0.04-0.04,0.07-0.07,0.1c-0.02,0.02-0.04,0.05-0.06,0.07c-0.02,0.02-0.05,0.03-0.08,0.05 c-0.03,0.02-0.07,0.04-0.1,0.06c-0.04,0.01-0.08,0.02-0.11,0.02c-0.03,0-0.06,0.02-0.09,0.02H6.33c-0.61,0-1.63-0.64-2.27-1.13 v-6.16c0.13-0.35,0.67-1.78,1.61-3.19c0.72-1.07,0.99-1.26,1.12-2.14c0.04-0.29,0.29-0.51,0.59-0.51h0.07 c0.31,0,0.57,0.25,0.57,0.57l0.02,4c0,0.22,0.12,0.42,0.3,0.53c0.01,0.01,0.02,0.01,0.03,0.02c0.04,0.02,0.08,0.02,0.13,0.03 c0.03,0.01,0.05,0.02,0.08,0.02c0.01,0,0.01,0,0.02,0c0.05,0,0.09-0.01,0.13-0.02c-0.04,0.01-0.07,0.02-0.12,0.02h0h4.74h0.02 c0.03,0,0.05,0.01,0.08,0.02c0.04,0.01,0.08,0.01,0.11,0.02c0.04,0.01,0.07,0.03,0.1,0.06c0.03,0.02,0.05,0.03,0.08,0.05 c0.02,0.02,0.04,0.04,0.06,0.07c0.03,0.03,0.05,0.06,0.07,0.1c0.01,0.02,0.02,0.05,0.03,0.08c0.01,0.04,0.02,0.07,0.02,0.11 c0.01,0.05,0,0.1,0,0.15c0,0.03-0.01,0.06-0.02,0.09c-0.02,0.05-0.04,0.09-0.07,0.13c-0.02,0.02-0.03,0.05-0.05,0.07 c-0.03,0.04-0.08,0.07-0.12,0.1c-0.02,0.01-0.04,0.03-0.06,0.04c-0.07,0.03-0.15,0.05-0.23,0.05H12.8h-0.57 c-0.08,0-0.16,0.02-0.22,0.05c-0.02,0.01-0.04,0.03-0.06,0.04c-0.04,0.03-0.09,0.05-0.12,0.08c-0.02,0.02-0.03,0.05-0.05,0.07 c-0.03,0.04-0.05,0.07-0.07,0.11c-0.01,0.03-0.01,0.06-0.02,0.09c-0.01,0.04-0.02,0.08-0.02,0.12c0,0.01,0,0.01,0,0.01 c0,0.03,0.01,0.06,0.02,0.1c0.01,0.04,0.02,0.09,0.03,0.13c0,0.01,0.01,0.02,0.02,0.02c0.1,0.18,0.28,0.31,0.5,0.31h0.03h0.54h0.56 h0.57c0.08,0,0.16,0.02,0.23,0.05c0.02,0.01,0.04,0.03,0.06,0.04c0.04,0.03,0.09,0.06,0.12,0.1c0.02,0.02,0.03,0.05,0.05,0.07 c0.03,0.04,0.05,0.08,0.07,0.13c0.01,0.03,0.01,0.06,0.02,0.09c0,0.03,0.02,0.05,0.02,0.08c0,0.02-0.01,0.04-0.01,0.07 c0,0.04-0.01,0.08-0.02,0.11c-0.01,0.03-0.02,0.05-0.03,0.08c-0.02,0.04-0.04,0.07-0.07,0.1c-0.02,0.02-0.04,0.05-0.06,0.07 c-0.02,0.02-0.05,0.03-0.08,0.05c-0.03,0.02-0.07,0.04-0.1,0.06c-0.04,0.01-0.08,0.02-0.11,0.02c-0.03,0-0.05,0.02-0.08,0.02h-0.02 h-0.55H12.8h-0.57c-0.08,0-0.16,0.02-0.22,0.05c-0.02,0.01-0.04,0.03-0.06,0.04c-0.04,0.03-0.09,0.05-0.12,0.08 c-0.02,0.02-0.03,0.05-0.05,0.07c-0.03,0.04-0.05,0.07-0.07,0.11c-0.01,0.03-0.01,0.06-0.02,0.09c-0.01,0.04-0.02,0.08-0.02,0.12 c0,0.01,0,0.01,0,0.01c0,0.03,0.01,0.06,0.02,0.1c0.01,0.04,0.02,0.09,0.03,0.13c0,0.01,0.01,0.01,0.02,0.02 c0.1,0.18,0.28,0.31,0.5,0.31h0.03h0.54h0.56c0.08,0,0.16,0.02,0.23,0.05c0.02,0.01,0.04,0.03,0.06,0.04 c0.04,0.03,0.09,0.06,0.12,0.1c0.02,0.02,0.03,0.05,0.05,0.07c0.03,0.04,0.05,0.08,0.07,0.13c0.01,0.03,0.01,0.06,0.02,0.09 c0,0.03,0.02,0.05,0.02,0.08c0,0.02-0.01,0.04-0.01,0.07c0,0.04-0.01,0.08-0.02,0.11c-0.01,0.03-0.02,0.05-0.03,0.08 c-0.02,0.04-0.04,0.07-0.07,0.1c-0.02,0.03-0.04,0.05-0.06,0.07c-0.02,0.02-0.05,0.03-0.08,0.05c-0.03,0.02-0.07,0.04-0.1,0.06 c-0.04,0.01-0.08,0.02-0.11,0.02c-0.03,0-0.05,0.02-0.08,0.02h-0.02h-1.11h-0.01c0,0,0,0,0,0c-0.31,0-0.57,0.25-0.57,0.57 c0,0.31,0.25,0.57,0.57,0.57h-0.01c0.08,0,0.16,0.02,0.23,0.05c0.02,0.01,0.04,0.03,0.06,0.04c0.04,0.03,0.09,0.06,0.12,0.1 c0.02,0.02,0.03,0.05,0.05,0.07c0,0.01,0.01,0.01,0.01,0.02c0,0,0,0,0,0c0.02,0.03,0.04,0.07,0.06,0.11 c0.01,0.03,0.01,0.06,0.02,0.09c0.01,0.05,0.01,0.1,0,0.15C12.78,30.05,12.77,30.09,12.76,30.13z M15.07,11.99 c0-0.34-0.01-0.67,0.01-0.99c0.02-0.41,0.04-0.77,0.13-1.1c0.31-1.19,1.04-1.86,2.17-1.98c0.77-0.09,1.55-0.09,2.37-0.1 c0.16,0,0.33,0,0.49-0.01v1.83l-0.32,0c-0.34,0-0.68,0-1.02,0c-0.79,0.01-1.32,0.49-1.36,1.26c-0.02,0.36-0.02,0.71-0.01,1.08 c0,0.16,0,0.31,0,0.47v0.6h2.71l-0.21,2.3h-2.63v8.71h-2.3l0-1.36c0-2.16,0-4.32,0-6.48c0-0.12,0-0.42-0.24-0.66 c-0.24-0.23-0.55-0.22-0.65-0.22c-0.28,0.01-0.56,0.01-0.86,0.01v-2.3h1.72v-0.6C15.07,12.31,15.07,12.15,15.07,11.99z  M30.61,23.93c-0.01,3.15-2.6,5.72-5.77,5.72c-3.32,0-6.88,0.01-10.94,0c-0.02-0.12-0.05-0.23-0.09-0.34 c0.72-0.2,1.26-0.86,1.26-1.64c0-0.3-0.08-0.59-0.22-0.84c0.47-0.3,0.79-0.83,0.79-1.44c0-0.05-0.01-0.1-0.02-0.15h2.97v-8.71h2.52 l0.43-4.69h-2.83c0-0.31-0.01-0.6,0.01-0.89c0-0.08,0.02-0.1,0.02-0.1c0,0,0.04-0.03,0.17-0.03c0.33,0,0.66,0,1,0l1.52,0V6.59 l-0.61,0.02c-0.36,0.01-0.73,0.01-1.08,0.02c-0.82,0.01-1.66,0.02-2.49,0.11c-1.63,0.18-2.76,1.2-3.19,2.87 c-0.11,0.44-0.14,0.88-0.16,1.34c-0.02,0.31-0.01,0.62-0.01,0.92h-1.72v4.68h0.6c0.14,0,0.29,0,0.43,0c0.23,0,0.47,0,0.72,0 c0,1.66,0,3.31,0,4.97c-0.17-0.06-0.35-0.09-0.54-0.09H9.17l-0.02-3.47c0-0.94-0.85-1.79-1.79-1.75c-0.13,0.01-0.39,0.02-0.51,0.04 c-0.51,0.1-0.91,0.66-1.05,1.18c-0.19,0.7-0.34,0.88-1.07,1.98c-0.66,0.99-1.13,1.97-1.42,2.65c-0.12-0.04-0.24-0.07-0.38-0.07 h-0.1c0-1.26,0-2.52,0-3.78l0-2.48c0-0.82,0-1.64-0.01-2.46C2.81,11.44,2.8,9.55,2.83,7.7c0.04-2.54,1.2-4.3,3.55-5.4 C7.02,2,7.74,1.85,8.53,1.85l3.93,0c1.86,0,3.75,0,5.65,0c2.27,0,4.54,0,6.8,0.01c3.08,0.01,5.69,2.62,5.7,5.7 C30.62,12.94,30.62,18.45,30.61,23.93z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLike);
export default __webpack_public_path__ + "static/media/facebook-like.700d69ce338e1c9226c8c6bd3e4312ee.svg";
export { ForwardRef as ReactComponent };